import { Box, Typography } from "@mui/material";
import React from "react";

const OfferingCard = ({ icon, title }) => {
  return (
    <Box
      sx={{
        width: { xs: "9rem", md: "12rem" },
        height: { xs: "8rem", sm: "10rem" },
        borderRadius: "0.8rem",
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
        padding: "1rem",
        backgroundColor: "white",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.05)",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
        }
      }}
    >
      <Box
        sx={{
          width: { xs: "2rem", sm: "3.5rem" },
        }}
      >
        <img src={icon} alt="" width="100%" />
      </Box>
      <Box>
        <Typography
          sx={{
            marginTop: "0.5rem",
            fontFamily: "Montserrat",
            color: "rgba(51, 51, 51, 1)",
            fontWeight: "500",
            fontSize: { xs: "0.7rem", sm: "0.9rem" },
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default OfferingCard; 